import './InventoryShop.css'
import { CaseData } from '../../../models/Case';
import { InventoryCard } from './InventoryCard/InventoryCard';
import { useEffect, useState } from 'react';
import UserService from '../../../services/UserService';
import toast from 'react-hot-toast';
import { useStore } from '../../../store/store';
import { translations } from '../../../configs/translations';
import { DonateItem } from '../../../models/DonateItem';

export const InventoryShop = () => {

    const [items, setItems] = useState<DonateItem[]>([])

    const language = useStore(state => state.language) as keyof typeof translations;
    const t = translations[language];

    useEffect(() => {
        fetchItems()
    }, [])

    const [openMenuIndex, setOpenMenuIndex] = useState<number | null>(null);

    const handleSetContextMenuOpen = (index: number, isOpen: boolean) => {
        setOpenMenuIndex(isOpen ? index : null);
    };

    const closeAllMenues = () => {
        setOpenMenuIndex(null);
    };

    const fetchItems = async () => {
        await UserService.fetchInventory()
            .then((response) => {
                setItems(response);
            })
            .catch((error) => {
                toast.error(
                    error && error.response && error.response.data && t[error.response.data as keyof typeof t] 
                        ? t[error.response.data as keyof typeof t] 
                        : t.error_unknown,
                    { className: 'notification-error' }
                );
            });
    }

    return (
        <div className="inventory-container">            
            <div className="inventory-cards-container">
                {items?.map((item: DonateItem, idx: number) => (
                    <InventoryCard 
                        key={idx}
                        item={item}
                        onButtonClick={() => { } }
                        isContextMenuOpen={openMenuIndex === idx}
                        setContextMenuOpen={(isOpen) => handleSetContextMenuOpen(idx, isOpen)}
                        closeAllMenues={closeAllMenues}
                        fetchItems={fetchItems}
                    />
                ))}
            </div>
        </div>
    )
}